export class OrderListHtmlRequest {
  orderIds?: number[];

}
